exports.components = {
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-instrucoes-js": () => import("./../../../src/pages/instrucoes.js" /* webpackChunkName: "component---src-pages-instrucoes-js" */)
}

